import { isProduction } from '@pst/biz';

export function navToNewsDetail(id: string, type: 'news' | 'updates') {
  const url = new URL(window.location.href);
  url.pathname = isProduction ? '/news' : '/pst/news';
  url.searchParams.set('id', id);
  url.searchParams.set('type', type);
  window.location.href = url.href;
}
